import { useRef, useState, useEffect } from "react";

const TESTIMONIALS = [

  {
    img: "/test1.png",
    text: "Thoughtful merch designs for promotions, crew, and actors. Everything felt film-appropriate and well executed",
    reply: "Glad to help",
    author: "Siemens",
    avatar: "/siemens.png",
  },
  {
    img: "/test2.png",
    text: "Designs were on point, delivery was earlier than expected, and quality impressed us enough to place repeat orders",
    reply: "Great experience overall.",
    author: "JRS Pharmaceuticals",
    avatar: "/jrs.png",
  },
  {
    img: "/test3.png",
    text: "Great T-shirt quality with creative designs that clearly communicated what our business is about",
    reply: "Great experience.",
    author: "Ye Re Ye Re Paisa 3",
    avatar: "/yere.png",
  },
  {
    img: "/test4.png",
    text: "Custom colours, clean prints, and premium fabric quality — everything matched our brand expectations perfectly",
    reply: "Happy you liked it",
    author: "Shree Motors",
    avatar: "/shree.png",
  },

];


export default function Testimonials() {
  const railRef = useRef(null);
  const cardRef = useRef(null);
  const [active, setActive] = useState(0);

  useEffect(() => {
    const rail = railRef.current;
    const card = cardRef.current;
    if (!rail || !card) return;

    const onScroll = () => {
      const cardWidth = card.offsetWidth + 20;
      setActive(Math.round(rail.scrollLeft / cardWidth));
    };

    rail.addEventListener("scroll", onScroll, { passive: true });
    return () => rail.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section
      className="w-full bg-[#f7f6f4] overflow-hidden py-[4vh] px-[4vw]"
    >
      <div className="max-w-[1560px] mx-auto h-full flex flex-col justify-between">

        {/* HEADING */}
        <div className="text-center">
          <h2
            style={{
              fontFamily: "'PP Neue Montreal', sans-serif",
              fontWeight: 400,
              fontSize: "clamp(36px, 4.5vw, 60px)",
              lineHeight: "1.18",
              letterSpacing: "0.05em",
              color: "#0b0b0b",
            }}
          >
            <span style={{ display: "block" }}>What Clients Say After</span>
            <span style={{ display: "block" }}>Working With Us</span>
          </h2>
        </div>

        {/* SLIDER */}
        <div
          ref={railRef}
          className="
            flex gap-4
            overflow-x-auto
            snap-x snap-proximity
            py-6
            [&::-webkit-scrollbar]:hidden
          "
        >
          {TESTIMONIALS.map((item, i) => (
            <div
              key={i}
              ref={i === 0 ? cardRef : null}
              className="
                snap-start
                shrink-0
                bg-white
                rounded-xl
                shadow-sm
                flex flex-col
                w-[72vw]
                sm:w-[48vw]
                md:w-[340px]
                aspect-[340/440]
              "
            >
              <div className="aspect-[340/180] bg-[#f2f2f2]">
                <img
                  src={item.img}
                  alt=""
                  className="w-full h-full object-contain"
                />
              </div>

              <div className="flex flex-col gap-3 px-4 py-3 flex-grow">
                <div className="bg-[#f3f3f3] px-3 py-2 text-[13px] leading-[1.4] max-w-[85%] rounded-t-lg rounded-br-lg">
                  {item.text}
                </div>

                <div className="bg-[#ececec] px-3 py-2 text-[12px] self-end rounded-t-lg rounded-bl-lg">
                  {item.reply}
                </div>
              </div>

              <div className="flex items-center px-4 py-2 gap-3">
                <img
                  src={item.avatar}
                  alt={item.author}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <span className="text-[12px] font-medium">
                  {item.author}
                </span>
              </div>

            </div>
          ))}
        </div>

        <div className="flex justify-center gap-3 md:hidden">
          {TESTIMONIALS.map((_, i) => (
            <span
              key={i}
              className={`h-2 rounded-full transition-all ${
                active === i ? "w-6 bg-black" : "w-2 bg-gray-300"
              }`}
            />
          ))}
        </div>

      </div>
    </section>
  );
}
